import { render, staticRenderFns } from "./email-query.vue?vue&type=template&id=0fafac5f&scoped=true"
import script from "./email-query.vue?vue&type=script&lang=js"
export * from "./email-query.vue?vue&type=script&lang=js"
import style0 from "./email-query.vue?vue&type=style&index=0&id=0fafac5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafac5f",
  null
  
)

export default component.exports